import { cn } from '@lair-finance/util'
import { forwardRef } from 'react'

export type ButtonProps = {
  variant?: 'Primary' | 'Secondary' | 'Outline'
  size?: 'sm' | 'md' | 'lg'
  className?: string
  focus?: boolean
  error?: boolean
  disabled?: boolean
  onClick?: () => void
  children?: React.ReactNode
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant, size = 'md', className, focus, disabled, error, onClick, children },
  ref,
) {
  return (
    <button
      ref={ref}
      className={cn(
        'inline-flex-center border border-primary-500 text-center bg-primary-500 text-greyscale-100 transition-colors duration-200 ease-in-out hover:bg-greyscale-100 hover:border-greyscale-100 hover:text-greyscale-900',
        { 'px-4 typo-new-label-3 h-[36px] rounded-[8px]': size === 'sm' },
        { 'px-8 typo-new-label-2 h-[48px] rounded-[12px]': size === 'md' },
        { 'px-8 typo-new-label-1 h-[56px] rounded-[16px]': size === 'lg' },
        {
          'bg-greyscale-500 border-greyscale-500 hover:text-greyscale-900 hover:bg-greyscale-100 hover:border-greyscale-100': variant === 'Secondary',
        },
        {
          'bg-greyscale-700 border-greyscale-500 hover:bg-greyscale-500 hover:border-greyscale-500 hover:text-greyscale-100': variant === 'Outline',
        },
        { '!border-greyscale-100': focus },
        {
          '!bg-greyscale-300 !border-greyscale-300 !text-greyscale-700': disabled,
        },
        { '!bg-palette-red !border-palette-red !text-greyscale-100': error },
        className,
      )}
      onClick={onClick}
      disabled={error || disabled}
    >
      {children}
    </button>
  )
})
